import { useTranslation } from 'hooks';
import { LineChartData } from 'reducers/home';
import { LineChartView } from './LineChartView';
import { Skeleton } from 'components/ui/skeleton';
import Button from 'components/ui/button';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { WL_ID_19 } from 'constants/wlIds';

interface Props {
  data?: LineChartData;
  isLoading: boolean;
  isError: boolean;
  onFetch: () => void;
}

export const LineChart: React.FC<Props> = ({
  data,
  isLoading,
  isError,
  onFetch,
}) => {
  const getTranslate = useTranslation();
  const wlId = useSelector((state: RootState) => state.settings.wlId);
  const CONTAINER_HEIGHT = wlId === WL_ID_19 ? 291 : undefined;

  if (!data || isLoading || isError) {
    return (
      <>
        <div className='flex justify-between items-center'>
          <Skeleton height={14} width='40%' />
          {isError ? (
            <Button
              id='refresh'
              status='light'
              icon='im-Refill'
              iconSize={14}
              iconPosition='left'
              text='Refresh'
              onClick={onFetch}
            />
          ) : null}
        </div>
        <div className='line-chart__header flex gap-8'>
          <div className='line-chart__item' style={{ maxWidth: 162, width: '100%' }}>
            <div className='line-chart__item-top w-full flex items-center gap-2 mb-1'>
              <Skeleton height={27} width={56} />
              <Skeleton height={27} width={32} />
            </div>
            <Skeleton height={17} width='100%' />
          </div>
          <div className='line-chart__item' style={{ maxWidth: 162, width: '100%' }}>
            <div className='line-chart__item-top w-full flex items-center gap-2 mb-1'>
              <Skeleton height={27} width={56} />
              <Skeleton height={27} width={32} />
            </div>
            <Skeleton height={17} width='100%' />
          </div>
        </div>
        <Skeleton height={140} />
      </>
    );
  }

  return (
    <>
      <h5 className='text-l-medium'>{getTranslate(data.title)}</h5>
      <LineChartView data={data} containerHeight={CONTAINER_HEIGHT} />
    </>
  );
};
